import classes from 'classnames';
import React from 'react';
import styles from './TableRow.module.scss';

export type TableRowProps = {
  name?: string;
  label: string;
  value?: string;
  secondaryValue?: string;
  isStrong?: boolean;
  dataTest?: string;
  className?: string;
};

export default function TableRow({
  label,
  value,
  secondaryValue,
  isStrong = false,
  className,
  dataTest,
}: TableRowProps) {
  return (
    <div
      className={classes(
        styles.row,
        isStrong && styles.strong,
        secondaryValue && styles['row-with-secondary'],
        className,
      )}
      data-test={dataTest}
    >
      <div dangerouslySetInnerHTML={{ __html: label }}></div>
      <div className={styles.value}>
        {value}
        {secondaryValue && (
          <div className={styles['secondary-value']}>{secondaryValue}</div>
        )}
      </div>
    </div>
  );
}
